'use client';

import { getCachedCosmicObject } from '@finn/auto-ui/utils/cosmic';
import { useEffect, useState } from 'react';

import ErrorPage from '~/components/ErrorPage';

const CustomErrorPage = ({ error }: { error: Error }) => {
  const [pageData, setPageData] = useState();

  useEffect(() => {
    getCachedCosmicObject({
      slug: 'static-error-page',
      locale: 'de-DE',
    }).then((data) => {
      setPageData(data);
    });
  }, []);

  if (!pageData) {
    return null;
  }

  return <ErrorPage pageData={pageData} statusCode={500} error={error} />;
};

export default CustomErrorPage;
